import * as mobxReact from 'mobx-react';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { CommonModal } from '../../../../../global/modal/common/common-modal';
import { ConnectionType } from '../../../../../../api/connections.dao';
import { ConfigurePassportDisplayFieldKey, PASSPORT_CONFIGURATION_OTHER_CONNECTIONS } from '../configure-passport-display.config';
import { ConfigurePassportPreviewPresentation } from './configure-passport-preview-presentation';
import ConfigurePassportDisplayVM from '../configure-passport-display.viewmodel';
import './configure-passport-preview-popover.scss';

export interface IPassportPreviewModalProps extends IBodyProps {
    intl: IntlShape;
    titlePopover: string;
    popoverIsOpen: boolean;
}

interface IBodyProps {
    closePopover: () => void;
    vm: ConfigurePassportDisplayVM;
}

const ModalBody =
    mobxReact.observer((props: IBodyProps) => {
        const { vm } = props;

        const {
            formVM,
            connection,
            phoneNumbersSet
        } = vm;

        const passportLabel = formVM.getValue(ConfigurePassportDisplayFieldKey.PASSPORT_LABEL) as string;
        const passportDescription = formVM.getValue(ConfigurePassportDisplayFieldKey.PASSPORT_DESCRIPTION) as string;

        const otherConnections = (PASSPORT_CONFIGURATION_OTHER_CONNECTIONS.includes(vm.connectionType as ConnectionType));
        const connectButtonLabel = formVM.getValue(ConfigurePassportDisplayFieldKey.CONNECT_BUTTON_LABEL) as string;
        const connectionDetailsEnabled = !!formVM.getValue(ConfigurePassportDisplayFieldKey.CONNECT_DETAILS_ENABLED);

        return (
            <ConfigurePassportPreviewPresentation
                passportLabel={passportLabel}
                passportDescription={passportDescription}
                connection={connection}
                otherConnections={otherConnections}
                connectButtonLabel={connectButtonLabel}
                connectionDetailsEnabled={connectionDetailsEnabled}
                phoneNumbersSet={phoneNumbersSet}
                passportConfigurationMode={vm.passportConfigurationMode}
                formVM={formVM}
                connectionType={vm.connectionType}
                className='passport-preview-popover-body'
                isConnectionGroup={false}
            />
        );
    });

const ConfigurePassportPreviewPopover = injectIntl((props: IPassportPreviewModalProps) => {
    const {
        titlePopover,
        popoverIsOpen,
        ...rest
    } = props;

    return (
        <CommonModal
            title={titlePopover}
            isOpen={popoverIsOpen}
            onRequestClose={props.closePopover}
            className='passport-preview-popover'
        >
            <ModalBody {...rest} />
        </CommonModal>
    );
});

export { ConfigurePassportPreviewPopover };
